import { PatientType } from '@nkr/enums/patient-type';

export interface IHardToMatchPair {
    recipientId: number,
    recipientAlias: string,
    recipientCenterId: number,
    recipientCenterAlias: string,
    recipientPatientType: PatientType | null,
    recipientBloodType: string,
    recipientAge: number,
    recipientCpra: number | null,
    recipientEstimatedWaitTime: number,
    recipientActiveWaitMonths: number | null,
    recipientIsOnDialysis: boolean | null,
    donorId: number,
    donorAlias: string,
    donorCenterId: number,
    donorCenterAlias: string,
    isChainStart: boolean,
    surgeryDate: string | null,
    donorBloodType: string,
    donorAge: number,
    donorLaterality: string,
    donorCreatinineClearance: number,
    singleEpletMmDr: number | null,
    singleEpletMmDq: number | null,
    singleEpletMmDqLow: number | null,
    totalEpletMmDr: number | null,
    totalEpletMmDq: number | null,
    hlaMatchPoints: number,
    avoidsCount: number,
    avoidsList: string,
    reviewStatus: number | null,
    reviewNote: string | null,
    reviewUpdatedDate: string | null,
    epletMmRisk: string,
    recipientPatientTypeValue: string | null,
    reviewStatusDescription: string | null,
    isHidden: boolean
}
